import Model from 'src/app/core/models/model';

export default class SessionModel extends Model {
  userID?: string;
  userAgent?: string;
  refreshToken?: string;
  userIP?: string;
  userDeviceVersion?: string;
  userDeviceOS?: string;
  userACLAlias?: Array<string>;
  loginTime?: Date;
  loginExpire?: Date;
  active?: boolean;
  pushNotificationKey?: string;
  appName?: Array<string>;
  isPasswordRested?: boolean;
  userName?: string;
  password?: string;
  personID?: string;
  businessID?: string;
  status?: boolean;
  message?: string;
  user: object;
  tokens: IToken;

  constructor() {
    super();
  }
}

export class IToken {
  token: string;
  refreshtoken: string;
  constructor() {
  }
}

//////////////////////////////
//ISession
//////////////////////////////
export class ISession {
  id: string;
  appName?: Array<string>;
  isPasswordRested?: boolean;
  userName?: string;
  updatedAt: Date;
  createdAt: Date;
  personID?: string;
  businessID?: string;
  routeIds?: Array<IRoutes>;

  constructor() {
    this.routeIds = new Array();
  }
}

//////////////////////////////
//IRoutes
//////////////////////////////
export class IRoutes {
  routeID: string;
  methods: Array<string>;

  constructor() {
  }
}
